import { Injectable, EventEmitter, Output } from '@angular/core';
import { Router, NavigationEnd, ActivatedRouteSnapshot, ActivatedRoute, PRIMARY_OUTLET } from '@angular/router';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

/*
 *
 */
export interface Path {
  data: Object;
  params: Object;
  url: string;
}

/*
 *
 */
export interface Paths extends Array<Path>{};
export class RoutingService {
public onChange: BehaviorSubject<Paths> = new BehaviorSubject(undefined);
/**
 * \@method constructor
 * @param {?} router
 */
constructor(
private router: Router
  ) {
    this.init();
  }
/**
 * [init description]
 * \@method init
 * @return {?}
 */
private init(): void {
    this.router.events.subscribe(routeEvent => {
      if(routeEvent instanceof NavigationEnd) {
        let /** @type {?} */ route = this.router.routerState.root.snapshot, /** @type {?} */
          tmpUrl= '', /** @type {?} */
          url = '', /** @type {?} */
          paths: Paths = [], /** @type {?} */
          rootRoot = true;

        while(route.children.length) {
          route = route.firstChild;
          tmpUrl = `/${this.createUrl(route)}`;

          if(route.outlet !== PRIMARY_OUTLET || (!route.routeConfig.path && !rootRoot)) {
            continue;
          }

          rootRoot = false;

          if(route.params || route.data) {
            for(let /** @type {?} */ key in route.params) {
              if(route.data['title']) {
                route.data['title'] = route.data['title'].replace(`:${key}`, route.params[key]);
              }
              if(route.data['breadcrumbs']) {
                route.data['breadcrumbs'] = route.data['breadcrumbs'].replace(`:${key}`, route.params[key]);
              }
              if(route.data['description']) {
                route.data['description'] = route.data['description'].replace(`:${key}`, route.params[key]);
              }
            }
          }

          if(tmpUrl === '/') {
            paths.push(this.createBreadcrumb(route, tmpUrl));
          } else {
            url += tmpUrl;
            paths.push(this.createBreadcrumb(route, url));
          }
        }

        this.onChange.next(paths);
      }
    });
  }
/**
 * [createBreadcrumb description]
 * \@method createBreadcrumb
 * @param {?} route
 * @param {?} url
 * @return {?}
 */
private createBreadcrumb(route: ActivatedRouteSnapshot, url: string): Path {
    if(route.children.length !== 0 && route.firstChild.routeConfig.path) {
      var /** @type {?} */ isUrl = true;
      if(url !== '/' && !route.routeConfig.loadChildren && !route.routeConfig.component && !this.isChildrenSelfRoute(route)) {
        isUrl = false;
      }
    }

    return {
      data: route.data,
      params : route.params,
      url: isUrl ? url : null
    }
  }
/**
 * [isChildrenSelfRoute description]
 * \@method isChildrenSelfRoute
 * @param {?} route
 * @return {?}
 */
private isChildrenSelfRoute(route: ActivatedRouteSnapshot): boolean {
    let /** @type {?} */ children = route.routeConfig.children;
    for(let /** @type {?} */ index in children) {
      if(children[index].path === '' && (children[index].component || children[index].loadChildren)) {
        return true;
      }
    }
  }
/**
 * [createUrl description]
 * \@method createUrl
 * @param {?} route
 * @return {?}
 */
private createUrl(route: ActivatedRouteSnapshot): string {
    return route.url.map(urlSegment => urlSegment.toString()).join('/');
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Router, },
];
}

function RoutingService_tsickle_Closure_declarations() {
/** @type {?} */
RoutingService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RoutingService.ctorParameters;
/** @type {?} */
RoutingService.prototype.onChange;
/** @type {?} */
RoutingService.prototype.router;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
